<button *ngIf="buttontext && !dependentFunctionName" [ngClass]="class">
    {{ buttontext }}
</button>

<ng-template #htmlContent>
    <div class="popoverCustomWidth">
        {{
        "trial_unsubscribe_tool_tip_text1"
        | translate : param
        }}
        {{ this.dependentFunctionName }}.
        {{
        "trial_unsubscribe_tool_tip_text2"
        | translate : param
        }}
        {{ this.dependentFunctionName }}
        {{
        "trial_unsubscribe_tool_tip_text3"
        | translate : param
        }}
    </div>
</ng-template>


<button *ngIf="buttontext && dependentFunctionName" [ngClass]="class" [ngbPopover]="htmlContent"
     triggers="mouseenter:mouseleave"  container="body">
    {{ buttontext }}
</button>